<template>
  <div class="custom-tab">
    <div
      class="tab-item"
      v-for="(item, index) in ARRAY"
      :key="index"
      :class="activeIndex === index ? 'active-tab-item' : ''"
      :ref="`tab${index}`"
      @click="toActive(index)"
    >
      {{ item }}
    </div>
    <div class="tab-line"></div>
  </div>
</template>

<script>
import gsap from "gsap";

export default {
  props: {
    // 默认激活项
    ACTIVE: {
      type: Number,
      default: () => 0,
    },
    // 列表
    ARRAY: {
      type: Array,
      default: () => ["全部"],
    },
  },
  data() {
    return {};
  },
  computed: {
    activeIndex() {
      return this.ACTIVE;
    },
  },
  methods: {
    toActive(index) {
      if (this.activeIndex === index) return;
      this.$emit("change", index);
      const gsp = gsap.timeline();
      gsp.fromTo(
        this.$refs[`tab${index}`],
        {
          opacity: 0,
        },
        {
          opacity: 1,
          duration: 1,
          ease: "power2.out",
        }
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.custom-tab {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  //border-bottom: 1px solid #D9D9D9;

  .tab-line {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    height: 1px;
    background-color: #d9d9d9;
  }

  .tab-item {
    margin-right: 48px;
    height: 50px;
    line-height: 50px;
    font-weight: 400;
    font-size: 16px;
    color: #999999;
    z-index: 10;

    &:last-child {
      margin-right: 0;
    }

    &:hover {
      cursor: pointer;
    }
  }

  .active-tab-item {
    color: #0067db;
    font-weight: 500;
    border-bottom: 2px solid #0067db;
  }
}
</style>
